import Beholder, { AmplitudeSchema } from '@easynvest/beholder'
import isHomolog from 'utils/isHomolog'

const _apiKey = isHomolog(window.location.host)
  ? 'e3fbb0d156ed1be30f4f7c6adeb7bffb' : '7a676a2024a2257e6216e6619b834cf6'
const _publicId = localStorage.getItem('public_id')

const eye = new Beholder()
eye.init(AmplitudeSchema.build(_apiKey, _publicId))

export default eye
